import { render, staticRenderFns } from "./register.component.vue?vue&type=template&id=3be596f0"
import script from "./register.component.vue?vue&type=script&lang=js"
export * from "./register.component.vue?vue&type=script&lang=js"
import style0 from "./register.component.vue?vue&type=style&index=0&id=3be596f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports